import axios from 'axios';
import { isArray, isPlainObject } from 'lodash';
import { apiBaseURL } from 'Src/config';
import snakizeKeys from 'Src/utils/snakizeKeys';
import { serialize } from 'object-to-formdata';
import {
  set, get, ACCESS_TOKEN, UID, CLIENT,
} from 'Src/storage';
import store from 'Src/store';
import { apiError } from 'Src/actions';

const buildDefaultHeader = (param, name) => {
  const header = param ? { [name]: param } : {};
  return header;
};

const storedToken = get(ACCESS_TOKEN);
const storedUid = get(UID);
const storedClient = get(CLIENT);

const tokenHeader = buildDefaultHeader(storedToken, 'access-token');
const uidHeader = buildDefaultHeader(storedUid, 'uid');
const clientHeader = buildDefaultHeader(storedClient, 'client');

let authHeaders = { ...tokenHeader, ...uidHeader, ...clientHeader };

const defaultErrorHandler = (error) => {
  const { dispatch } = store;
  dispatch(apiError(error));
};

const setAuthHeaders = (accessToken, uid, client) => {
  authHeaders = { 'access-token': accessToken, uid, client };
  set(ACCESS_TOKEN, accessToken);
  set(UID, uid);
  set(CLIENT, client);
};

const hasFile = (payload) => {
  if (payload instanceof window.File) return true;
  if (isArray(payload)) return payload.some(value => hasFile(value));
  if (isPlainObject(payload)) return Object.values(payload).some(value => hasFile(value));
  return false;
};

const toFormData = payload => (hasFile(payload) ? serialize(payload) : payload);
const toJsonData = (payload) => {
  const decamelized = snakizeKeys(payload);
  return (isPlainObject(payload) ? decamelized : payload);
};


const apiClient = axios.create({
  withCredentials: false,
  baseURL: apiBaseURL,
  transformRequest: [].concat(toJsonData, toFormData, axios.defaults.transformRequest),
});


const handleResponseHeaders = (headers) => {
  const {
    'access-token': responseToken,
    uid: responseUid,
    client: responseClient,
  } = headers;

  if (responseToken && responseToken.length) {
    setAuthHeaders(responseToken, responseUid, responseClient);
  }
};

export const apiRequest = async (request, errorHandler = defaultErrorHandler) => {
  const { headers = {} } = request;
  const newHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...authHeaders,
    ...headers,
  };

  const newRequest = { ...request, headers: newHeaders };
  try {
    const response = await apiClient.request(newRequest);
    const { headers: responseHeaders = {} } = response;
    handleResponseHeaders(responseHeaders);
    return response;
  } catch (error) {
    const { response = {} } = error;
    const { headers: responseHeaders = {} } = response;
    handleResponseHeaders(responseHeaders);
    errorHandler(error);
    return response;
  }
};

export default apiClient;
